export default (text: string): boolean => {
  try {
    // eslint-disable-next-line no-new
    new URL(text);
    return true;
  } catch (_) {
    return false;
  }
};
